import React, { useState } from 'react';
import Select, { SelectProps } from 'antd/lib/select';
import { useQuery } from 'react-query';

import {
  getAllUsersListByAnyRef,
  GetUsersByAnyRefParams,
} from 'services/parametersService';

export type UsersProps = SelectProps<any> & {
  parentValue?: string;
};

const UsersInputByDepartment = (props: UsersProps) => {
  const [searchParams] = useState<GetUsersByAnyRefParams>({
    email: '',
    locked: false,
    mgid: Number(localStorage.getItem('mgid')) ?? undefined,
    mobile: '',
    name: '',
    phone: '',
    status: 'ENABLED',
    surname: '',
    username: '',
    userrole: '',
    userid: undefined,
    useridmanager: undefined,
  });

  const { data } = useQuery(
    ['getAllUsersListByAnyRef', searchParams],
    () => getAllUsersListByAnyRef(searchParams).then((res) => res.list ?? [])
  );

  return (
    <Select allowClear {...props}>
      {data?.map((user) => (
        <Select.Option value={user.id} key={user.id}>
          {user.surname + ' ' + user.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default UsersInputByDepartment;
